import React, { useEffect, useState } from "react";
import Feature from "./Feature";
import { useDispatch, useSelector } from "react-redux";
import { SelectSiteFunnelDBData,SelectSiteUserJourneyUserWeekLabels,setFunnelViewDBData,SelectSiteUsersDBData,setSiteUsersDBData} from "../../HeatmapXUserSegmentSlice";
import TempDropDown from "../../../../components/Graphs/PersonaPredictionGraphs/TempDropDown";
import Filter from "./Filter";
import { FirebaseDataService } from "../../../../services/firebase-data.service";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { set } from "date-fns";

const CF_Filters = {
  userType: {
    title: "Audience Type",
    options: [
      { id: "all", title: "All Users" },
      { id: "first_time", title: "First Time" },
      { id: "returning", title: "Returning" },
    ],
    value: "",
  },
  userSource: {
    title: "User Traffic Source",
    options: [
      { id: "all", title: "All Sources" },
      { id: "paid", title: "Paid" },
      { id: "organic", title: "Organic" },
    ],
    value: "",
  },
  referrers: {
    title: "Referrers",
    value: [],
  },
  utmParams: {
    title: "UTM Params",
    value: [], // array of { key, value }
  },
};

const CustomerJourney = () => {
  const dispatch = useDispatch();
  const UserFunnelDBData = useSelector(SelectSiteFunnelDBData);
  const SiteUsersWeekLabels = useSelector(SelectSiteUserJourneyUserWeekLabels);
  const SiteUsersDBData = useSelector(SelectSiteUsersDBData);
  const siteFunnelDBData = useSelector(SelectSiteFunnelDBData);
  const [weekLabels, setWeekLabels] = useState([]);
  const [currentWeek, setCurrentWeek] = useState("");
  const [currentWeekData, setCurrentWeekData] = useState(null);
  const [filterObj, setFilterObj] = useState({});
  const firebaseDataService = new FirebaseDataService();
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

  useEffect(() => {
    if (Object.keys(UserFunnelDBData).length) {
      const weeks = Object.keys(UserFunnelDBData);
      const latestWeek = weeks[0];
      setCurrentWeek(latestWeek);
      setCurrentWeekData(UserFunnelDBData[latestWeek]);
    }
  }, []);

  useEffect(() => {
    if (SiteUsersWeekLabels.length) {
      setWeekLabels(SiteUsersWeekLabels);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(filterObj).length) {
      const filteredData = applyFilterOnData(filterObj);
      setCurrentWeekData(filteredData);
    }
  }, [filterObj]);

  useEffect(() => {
    const fetchData = async () => {
      let [yy, mm, dd] = currentWeek.split("-");

      mm = String(mm).padStart(2, '0');
      dd = String(dd).padStart(2, '0');

      const cachedData = siteFunnelDBData?.[currentWeek];
      if (cachedData && Object.keys(cachedData).length > 0) {
        console.log(`Using Redux cached data for ${currentWeek}`);
        setCurrentWeek(currentWeek);
        setCurrentWeekData(cachedData);
        return; // No Firebase call needed!
      }

      console.log("user,yy, mm, dd", user,yy, mm, dd);
      const data = await firebaseDataService.getDataForDate(user, yy, mm, dd); 
      console.log("userJorneySelectedWeekData----->", data);
      console.log("data.journey", data?.journey);

      if (!data || Object.keys(data.journey).length === 0) {
        console.log("No data available for the selected week.");
        return;
      }
      setCurrentWeekData(data.journey ?? null);
      dispatch(setSiteUsersDBData({
        ...SiteUsersDBData,
        [currentWeek]: data.heatmap ?? {}
      }));
      dispatch(setFunnelViewDBData({
        ...siteFunnelDBData,
        [currentWeek] : data.journey ?? {}
      }));
    };
    
    if(currentWeek!==""){
      fetchData();
    }
  }, [currentWeek]);

  const applyFilterOnData = (filterObj) => {
    const root = UserFunnelDBData[currentWeek];
    if (!root) return null;

    const {
      userType = "",
      userSource = "",
      referrers = [],
      utmParams = [],
    } = filterObj;

    const filterTree = (node) => {
      if (!node) return null;

      // User Type filter
      const matchesUserType =
        !userType || userType === "all" || (node.userTypes?.[userType] > 0);

      // User Source filter
      const matchesUserSource =
        !userSource || userSource === "all" || (node.userSources?.[userSource] > 0);

      // Referrers filter
      const matchesReferrers =
        !referrers.length ||
        referrers.some((ref) =>
          node.referrers?.some(([refUrl]) =>
            refUrl.toLowerCase().includes(ref.toLowerCase())
          )
        );

      // UTM Params filter
      const matchesUTM =
        !utmParams.length ||
        utmParams.every(({ key, value }) =>
          node.URL?.includes(`${key}=${value}`)
        );

      const children = (node.children || [])
        .map(filterTree)
        .filter(Boolean); // Keep only valid subtrees

      const isMatch =
        matchesUserType && matchesUserSource && matchesReferrers && matchesUTM;

      if (isMatch || children.length > 0) {
        return {
          ...node,
          children,
        };
      }

      return null;
    };

    const filteredData = filterTree(root);
    console.log("Filtered Tree:", filteredData);

    return filteredData || null;
  };

  return (
    <div>
      <div className="flex justify-between items-center mt-[-32px]">
        <Filter
          CF_Filters={CF_Filters}
          CF_FilterObj={filterObj}
          setCF_FilterObj={setFilterObj}
        />
        <div className="border-[1.25px] w-fit rounded-md border-gray-200">
          <TempDropDown
            currentWeek={currentWeek}
            setCurrentWeek={setCurrentWeek}
            weeks={weekLabels}
          />
        </div>
      </div>

      {currentWeekData ? (
        <Feature data={currentWeekData} currentWeek={currentWeek} />
      ) : (
        <div className="text-center text-gray-500 mt-8">
          No data matches the selected filters.
        </div>
      )}
    </div>
  );
};

export default CustomerJourney;